import type { GIFData } from 'ricos-schema';
import { Node_Type } from 'ricos-schema';

import type { NodeBuilder } from './types';
import { isDefined } from './utils';

export const gif = (...args: (NodeBuilder | GIFData)[]): NodeBuilder => {
  const gifData = args.find((a): a is GIFData => !('type' in a));

  return {
    type: 'block_node',
    node: getId => ({
      id: getId(),
      type: Node_Type.GIF,
      nodes: args
        .map(arg => ('type' in arg && arg.type === 'block_node' ? arg.node(getId) : undefined))
        .filter(isDefined),
      gifData: gifData
        ? gifData
        : {
            height: 100,
            width: 101,
          },
    }),
  };
};
